import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import './LegalPages.scss';

const Disclaimer: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Disclaimer | App Developer Pro</title>
        <meta name="description" content="Read our disclaimer regarding the use of App Developer Pro services and website content." />
        <link rel="canonical" href="https://appdeveloperpro.com/disclaimer" />
      </Helmet>

      <div className="disclaimer-page">
        {/* Hero Section */}
        <section className="legal-hero">
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              <h1>Disclaimer</h1>
              <p>Last updated: January 2025</p>
            </motion.div>
          </div>
        </section>

        {/* Content Section */}
        <motion.section 
          className="legal-content"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="container">
            <article className="legal-article">
              <h2>Website Disclaimer</h2>
              <p>
                The information provided by App Developer Pro ("we," "us," or "our") on our website 
                (https://appdeveloperpro.com) is for general informational purposes only. All information 
                on the site is provided in good faith, however, we make no representation or warranty 
                of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, 
                availability, or completeness of any information on the site.
              </p>

              <h2>Professional Disclaimer</h2>
              <p>
                The site cannot and does not contain professional advice. The development and technology 
                information is provided for general informational and educational purposes only and is not 
                a substitute for professional advice. Accordingly, before taking any actions based upon 
                such information, we encourage you to consult with the appropriate professionals.
              </p>

              <h2>External Links Disclaimer</h2>
              <p>
                The site may contain (or you may be sent through the site) links to other websites or 
                content belonging to or originating from third parties or links to websites and features 
                in banners or other advertising. Such external links are not investigated, monitored, or 
                checked for accuracy, adequacy, validity, reliability, availability, or completeness by us.
              </p>
              <p>
                We do not warrant, endorse, guarantee, or assume responsibility for the accuracy or 
                reliability of any information offered by third-party websites linked through the site 
                or any website or feature linked in any banner or other advertising.
              </p>

              <h2>Testimonials Disclaimer</h2>
              <p>
                The site may contain testimonials by users of our products and/or services. These 
                testimonials reflect the real-life experiences and opinions of such users. However, 
                the experiences are personal to those particular users, and may not necessarily be 
                representative of all users of our products and/or services.
              </p>

              <h2>Errors and Omissions Disclaimer</h2>
              <p>
                While we have made every attempt to ensure that the information contained in this site 
                has been obtained from reliable sources, App Developer Pro is not responsible for any 
                errors or omissions, or for the results obtained from the use of this information.
              </p>

              <h2>Fair Use Disclaimer</h2>
              <p>
                This site may contain copyrighted material the use of which has not always been 
                specifically authorized by the copyright owner. We are making such material available 
                in our efforts to advance understanding of web development, technology, and related 
                topics. We believe this constitutes a "fair use" of any such copyrighted material.
              </p>

              <h2>Views Expressed Disclaimer</h2>
              <p>
                The views and opinions expressed in this website are those of the authors and do not 
                necessarily reflect the official policy or position of any other agency, organization, 
                employer, or company.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have any questions about this Disclaimer, please contact us:
              </p>
              <ul>
                <li>Email: info@appdeveloperpro.com</li>
                <li>Phone: +91 9999999999</li>
                <li>Address: 1st floor, Defence Enclave, Old Commercial Complex Sector 44, Sadarpur, Noida UP - 201303</li>
              </ul>
            </article>
          </div>
        </motion.section>
      </div>

      <style>{`
        .disclaimer-page {
          min-height: 100vh;
        }

        .legal-hero {
          background: linear-gradient(135deg, #0EA5E9 0%, #1E3A5F 100%);
          padding: 120px 0 80px;
          text-align: center;
          color: white;
        }

        .legal-hero h1 {
          font-size: 3rem;
          font-weight: 700;
          margin-bottom: 1rem;
        }

        .legal-hero p {
          opacity: 0.9;
        }

        .container {
          max-width: 900px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .legal-content {
          padding: 80px 0;
          background: #fff;
        }

        .legal-article {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #333;
        }

        .legal-article h2 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1a1a2e;
          margin: 40px 0 20px;
        }

        .legal-article h2:first-of-type {
          margin-top: 0;
        }

        .legal-article p {
          margin-bottom: 20px;
        }

        .legal-article ul {
          margin: 20px 0;
          padding-left: 30px;
        }

        .legal-article li {
          margin-bottom: 10px;
        }

        @media (max-width: 768px) {
          .legal-hero h1 {
            font-size: 2rem;
          }

          .legal-article {
            font-size: 1rem;
          }
        }
      `}</style>
    </>
  );
};

export default Disclaimer;

